export const WIDE_ELEMENTS_SELECTOR = '[wide-content]';
